/** Group permission names like "project:update" into readable lines. */
const RESOURCE_LABEL: Record<string, string> = {
  portfolio: 'Portfolios', program: 'Programs', project: 'Projects', task: 'Tasks', user: 'Users',
  role: 'Roles', report: 'Reports', dashboard: 'Dashboards', admin: 'Workspace admin', budget: 'Budgets',
  risk: 'Risks', document: 'Documents', resource: 'Resources', integration: 'Integrations',
}
const ACTION_LABEL: Record<string, string> = {
  read: 'view', create: 'create', update: 'edit', delete: 'delete', manage: 'manage', approve: 'approve', export: 'export',
}

export function summarisePermissions(names: string[]): Array<{ resource: string; actions: string[] }> {
  const byResource = new Map<string, string[]>()
  for (const n of names) {
    const [res, act] = n.split(':')
    if (!res || !act) continue
    const list = byResource.get(res) ?? []
    list.push(ACTION_LABEL[act] ?? act)
    byResource.set(res, list)
  }
  return [...byResource.entries()]
    .map(([res, actions]) => ({ resource: RESOURCE_LABEL[res] ?? res.replace(/_/g, ' '), actions: [...new Set(actions)].sort() }))
    .sort((a, b) => a.resource.localeCompare(b.resource))
}
